import { render, staticRenderFns } from "./AutogenerateTest.vue?vue&type=template&id=21834141&scoped=true"
import script from "./AutogenerateTest.vue?vue&type=script&lang=js"
export * from "./AutogenerateTest.vue?vue&type=script&lang=js"
import style0 from "./AutogenerateTest.vue?vue&type=style&index=0&id=21834141&prod&lang=css"
import style1 from "./AutogenerateTest.vue?vue&type=style&index=1&id=21834141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21834141",
  null
  
)

export default component.exports